import { Address } from '@root/types';

export default function formatFullBuildingName({ street, buildingName }: Address): string {
  const buildingNamePrefix = buildingName ? `${buildingName} - ` : '';
  return `${buildingNamePrefix}${street}`;
}
